<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "comm"
    }
</script>

<style scoped>

</style>
